module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    on: {
      "ok": _vm.applyConfig,
      "cancel": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v("Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "body-contents",
    slot: "body"
  }, [_c('p', [_vm._v("\n      Select table columns:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("general")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptions),
      expression: "descriptions"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.descriptions) ? _vm._i(_vm.descriptions, null) > -1 : (_vm.descriptions)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.descriptions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.descriptions = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.descriptions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.descriptions = $$c
        }
      }
    }
  }), _vm._v("\n          description\n        ")])]), _vm._v(" "), _vm._l((_vm.allColumns), function(column) {
    return _c('div', {
      staticClass: "column"
    }, [(column.header) ? _c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(column.header))]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.selected),
        expression: "column.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(column.selected) ? _vm._i(column.selected, null) > -1 : (column.selected)
      },
      on: {
        "change": function($event) {
          _vm.selectColumn(column)
        },
        "__c": function($event) {
          var $$a = column.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (column.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (column.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            column.selected = $$c
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(_vm.shortLabel(column)) + "\n          "), (column.definition.hasPeriod && !column.selected) ? _c('span', [_vm._v("\n            day/month/year\n          ")]) : _vm._e()]), _vm._v(" "), (column.definition.hasPeriod && column.selected) ? _c('drop-down', {
      attrs: {
        "disabled": !column.selected,
        "value": column.period,
        "options": _vm.periodOptions,
        "showFilter": false,
        "title": "Click to select a period"
      },
      on: {
        "change": function (period) { return column.period = period; }
      }
    }) : _vm._e(), _vm._v(" "), (column.definition.hasTimezone && column.selected) ? _c('drop-down', {
      attrs: {
        "disabled": !column.selected,
        "value": column.timezone,
        "options": _vm.timezoneOptions,
        "title": "Click to select a timezone"
      },
      on: {
        "change": function (timezone) { return column.timezone = timezone; }
      }
    }) : _vm._e(), _vm._v(" "), (column.definition.category === 'unix') ? _c('span', [_vm._v("(s)")]) : _vm._e(), _vm._v(" "), (column.definition.category === 'timestamp') ? _c('span', [_vm._v("(ms)")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resetConfig
    }
  }, [_vm._v("reset to default")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a4f4fa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config.vue
// module id = 325
// module chunks = 0